// extracted by mini-css-extract-plugin
module.exports =  {"skeleton":"FOVtMbB1cPkAcKJCpF7z","skeleton-glow":"h5ci0FldOKpkUUG0A4cQ","skeletonGlow":"h5ci0FldOKpkUUG0A4cQ"};